// Browser TTS helper
let currentUtterance = null;

export function speak(text, opts = {}) {
  try {
    if (!("speechSynthesis" in window) || !text) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = opts.rate ?? 0.95;
    u.pitch = opts.pitch ?? 1.0;
    u.volume = opts.volume ?? 1.0;
    u.lang = opts.lang ?? "en-US";
    currentUtterance = u;
    window.speechSynthesis.speak(u);
  } catch (e) {
    // ignore
  }
}

export function stopSpeaking() {
  try { window.speechSynthesis.cancel(); } catch (e) {}
  currentUtterance = null;
}

export function isSpeaking() {
  return typeof window !== "undefined" && window.speechSynthesis && window.speechSynthesis.speaking;
}
